import "utils/sentry";
import "./i18n";
import "app/shared";
import { createRoot } from "react-dom/client";
import { injectTemplateScripts } from "app/shared/utils";
import "./styles/app.scss";
import "react-circular-progressbar/dist/styles.css";
import "antd/dist/reset.css";
import store from "app/store";
import App from "App";
import { BrowserRouter as Router } from "react-router-dom";
import { SharedProvider } from "@shared/app/SharedProvider";
import { ResizeObserver as Polyfill } from "@juggle/resize-observer";
import SocketProvider from "features/socket/SocketProvider";

export function initApp() {
  window.ResizeObserver = window.ResizeObserver || Polyfill;
  createRoot(document.getElementById("root")!).render(
    <SharedProvider store={store}>
      <SocketProvider>
        <Router>
          <App />
        </Router>
      </SocketProvider>
    </SharedProvider>
  );
  injectTemplateScripts(`${import.meta.env.VITE_APP_ENVIRONMENT}`);
}
